/**
 * Created by linjianxi on 2016/10/29.
 */
import * as actions from './actions'
import * as getters from './getter'
import * as types from './mutation-type'

const state = {
  gridData: {},
  tax: 0,
  amountaftertax: 0,
  rate: 0,
  total: 0,
  limitAmount: 0
}
const mutations = {
  [types.GET_HQPORD_INTO_LIST] (state, result) {
    // state.gridData = result
    state.tax = result.tax
    state.amountaftertax = result.amountaftertax
  },
  [types.GET_HQPORD_INTO_RECHANGE] (state, result) {
    state.tax = 0
    state.amountaftertax = 0
  },
  [types.GET_HQPORD_DETAIL] (state, result) {
    state.gridData = result.res.req
    state.rate = result.res.req.rate
    state.total = result.res.req.availablecash
    if (Number(result.res.req.limitAmount) <= 800) {
      state.limitAmount = 800
    } else {
      state.limitAmount = result.res.req.limitAmount
    }
    result.res._this.bankText = result.res.req.cards[0].OpenAccountBank
    result.res._this.bankLastNum = result.res.req.cards[0].BankCardNo
    result.res._this.bankValue = result.res.req.cards[0].AccountNo
    result.res._this.bankCode = result.res.req.cards[0].BankCode
    result.res._this.initSelect(result.res.req.cards)
  }
}
export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/hqpord_into/store.js